import React from 'react';
import SearchGreen from '../assets/images/SearchGreen.svg';

export default () => {
  return <img src={SearchGreen} alt="" />;
};
